// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__FnMO7","modalForm":"UpgradeEpcsModal_modalForm__36D4A","modalFooter":"UpgradeEpcsModal_modalFooter__2pTce"};